import { createReducer, on } from "@ngrx/store";
import { C_CategoryInfo } from "@sports-models/index";
import { liveMarketDataModel } from "@sports-models/index";
import * as SportsbookActions from "../../../../sports/stores/sportsbook/sportsbook.actions";

export const initialState: {
  prevLiveMarketData: liveMarketDataModel;
  currentLiveMarketData: liveMarketDataModel;
  categories: C_CategoryInfo[];
  selectedCategory: C_CategoryInfo;
  market: any;
} = {
  prevLiveMarketData: { CategoryInfos: [], Events: [] },
  currentLiveMarketData: { CategoryInfos: [], Events: [] },
  categories: [],
  selectedCategory: null,
  market: null,
};

export const SportsbookLiveMarketReducer = createReducer(
  initialState,
  // Live Market
  on(SportsbookActions.initLiveMarket, (state, { type, ...payload }) => ({
    ...state,
    market: payload.market,
  })),
  on(SportsbookActions.setLiveMarket, (state, { type, ...rest }) => ({
    ...state,
    ...rest,
  })),
  on(SportsbookActions.setLiveMarketBetsense, (state, { type, ...payload }) => ({
    ...state,
    betsenseData: payload.betsenseData,
  })),
  on(SportsbookActions.setLiveMarketSelectedCategory, (state, { type, ...payload }) => ({
    ...state,
    selectedCategory: payload.selectedCategory,
  })),
  on(SportsbookActions.clearLiveMarket, (state) => ({
    ...state,
    ...initialState,
  })),
);
